import { graphql } from "../generated";

// The Behind the Scenes of the series details page (SHO-757). Not
// @authenticated, but `locked` and `url` depend on the user: the route loader
// runs before boot holds a token, so there everyone would read `locked`.
// Fetched from a component, like the progression.
export const GET_SERIES_BEHIND_THE_SCENES = graphql(`
  query GetSeriesBehindTheScenes($showId: ID!) {
    show(id: $showId) {
      id
      behindTheScenes {
        id
        title
        displayTitle
        locked
        url
        thumbnail {
          original
        }
      }
    }
  }
`);
